/**
 * react-query options for the weekly check-in, keyed under her NOVA routines
 * so waking a routine refreshes it.
 *
 * Aliases: weekly check-in query, check-in state
 */

import { queryOptions } from "@tanstack/react-query";

import { getMyWeeklyCheckIn } from "~/lib/functions/weekly-check-in";
import { novaHomeQueryKeys } from "~/lib/queries/novaHomeQueryKeys";

export const weeklyCheckInQueryKey = [
  ...novaHomeQueryKeys.routines,
  "weekly_check_in",
] as const;

export const weeklyCheckInQueryOptions = () =>
  queryOptions({
    queryKey: weeklyCheckInQueryKey,
    queryFn: () => getMyWeeklyCheckIn(),
    staleTime: 30 * 1000,
  });
